import ProductItemPrice from "entities/product-item-price";
import { StandardOrderProduct } from "shared/api/middleware-api-client";
import { concatClassnames } from "shared/utils/concatClassnames";
import StandardProductPaymentDescription from "../shared/standard-product/payment-description";
import StandardProductItemPrice from "../standard-product-item-price";

interface StandardProductItemSidebarProps {
  product: StandardOrderProduct;
}

const StandardProductItemSidebar = ({
  product,
}: StandardProductItemSidebarProps) => {
  return (
    <>
      <div
        className={concatClassnames(
          "gg-col-span-12",
          "gg-grid gg-grid-cols-12"
        )}
      >
        <div
          className={concatClassnames(
            "gg-col-span-12 gg-justify-center gg-mb-0 sm:gg-mb-5"
          )}
        >
          <StandardProductPaymentDescription standardProduct={product} />
        </div>

        <StandardProductItemPrice
          className={`
          gg-col-span-12 gg-col-start-4 gg-ml-4 sm:gg-col-start-4 md:gg-ml-0 md:gg-col-span-2 lg:gg-col-start-4 lg:gg-col-span-2 xl:gg-col-start-6 xl:gg-col-span-12 2xl:gg-col-start-5 
          2xl:gg-flex gg-items-center gg-gap-x-4
        `}
          product={product}
        />
      </div>
    </>
  );
};
export default StandardProductItemSidebar;
